import { render, staticRenderFns } from "./WsiField.vue?vue&type=template&id=b351dfc6&scoped=true"
import script from "./WsiField.vue?vue&type=script&lang=js"
export * from "./WsiField.vue?vue&type=script&lang=js"
import style0 from "./WsiField.vue?vue&type=style&index=0&id=b351dfc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b351dfc6",
  null
  
)

export default component.exports